import { WINDOW } from "../constants/environment"

// TODO: WE NEED TO GET RID OF THIS API!

// set global namespace
const namespace = "__KOALA"

// expose function to window
const exposeGlobal = (slug, value) => {
  if (!WINDOW) return
  // http://webreflection.blogspot.com.au/2011/08/please-stop-reassigning-for-no-reason.html
  namespace in WINDOW || (WINDOW[namespace] = {})
  slug in WINDOW[namespace] &&
    console.warn(`${slug} exists in ${namespace} and will be over-written.`)

  WINDOW[namespace][slug] = value
}

export default exposeGlobal



// WEBPACK FOOTER //
// ./src/apis/expose-global.js